import triggerRecipientsChanged from '../utils/triggerRecipientsChanged';
import triggerLocationsChanged from '../utils/triggerLocationsChanged';
import { onResourcesChanged, updateResources } from 'owa-calendar-compose-form-actions';
import { orchestrator } from 'satcheljs';
import { RecipientFieldEnum } from 'owa-addins-core';

export default orchestrator(updateResources, actionMessage => {
    onResourcesChanged(actionMessage.resources);
    triggerRecipientsChanged(RecipientFieldEnum.Resources);
    triggerLocationsChanged();
});
